import { Wording } from '@/types';

export const MEDITATION_WORDING_RS: Wording = {
  components_header_media_content: 'Audio',
  components_header_media_1: 'Meditacije',
  components_header_media_2: 'Podkast',
  components_header_text1: 'Vodiči',
  components_header_text2: 'Blog',
  components_header_members: 'Članovi',
  hero_text: 'Mesto gde se meditacija susreće sa zvezdama',
  hero_button_text: 'Započnite svoje putovanje',
  components_ressources_section_title: 'RESURSI',
  components_ressources_subheader_text: 'Alati za unutrašnji mir, uzemljenje i svakodnevnu ravnotežu',
  components_ressources_span_text: 'Otvorite vrata unutrašnjem miru uz naše odabrane meditacije i vodiče. Pronađite jasnoću, ponovo se povežite sa svojim dahom i uskladite se sa svojim unutrašnjim ritmom - jedan po jedan svesni trenutak.',
  components_ressources_card_1_title: 'Refleksija',
  components_ressources_card_1_text: 'Kratke meditacije i audio refleksije za centriranje vaših misli i usklađivanje sa vašim kosmičkim ritmom.',
  components_ressources_card_2_title: 'Istražite dubine',
  components_ressources_card_2_text: 'Putujte izvan površine uz impresivne vodiče koji spajaju meditaciju, astrologiju i samoispitivanje za trajnu transformaciju.',
  components_ressources_link: 'Vidi više',
  components_notes_and_google_title_1: 'Duševni vodiči',
  components_notes_and_google_title_2: 'Pažljivi rituali',
  components_notes_and_google_title_3: 'Vođene meditacije',
  components_review_google_text: 'Google recenzije',
  media_content_section_title: 'AUDIO',
  media_content_section_subheader_text: 'Naše meditacije',
  text_media_1: '',
  text_media_2: '',
  media_content_section_button_more: 'Otkrijte više',
  text2_section_title: 'BLOG',
  text2_section_subheader_text: '',
  text2_section_button_more: '',
  components_text1_section_title: 'VODIČI',
  components_text1_subheader_text: 'Kosmičko znanje za svakodnevno usklađivanje',
  components_text1_span_text: 'Uskladite se sa ritmovima univerzuma: istražite odabranu kolekciju detaljnih astroloških i meditativnih vodiča dizajniranih da probude unutrašnju jasnoću, prodube samosvijest i podrže vaše putovanje duševnog, nebeskog rasta.',
  components_text1_card_1_title: 'Otvoreni za tišinu',
  components_text1_card_1_text: 'Započnite svoje putovanje temeljnim vodičima za meditaciju i astrologiju—idealno za tragaoce koje privlače unutrašnja tišina, kosmički obrasci i lični uvid.',
  components_text1_card_3_title: 'Veza um–telo',
  components_text1_card_3_text: 'Otkrijte dublje slojeve svog unutrašnjeg sveta. Ovi vodiči se kreću izvan površine kako bi otkrili značenje, emocije i svesne obrasce koji oblikuju vaše iskustvo.',
  components_text1_card_2_title: 'Samoispitivanje i integracija',
  components_text1_card_2_text: 'Od emocionalnih blokova do planetarnih ciklusa — ovi vodiči nude alate za razmišljanje, lečenje i transformaciju kroz svesne rituale i astrološku mudrost.',
  components_text1_link: 'Prikaži sve vodiče',
  components_footer_text: 'Probudite se iznutra: vaša tišina, vaša snaga',
  components_footer_info: 'Info',
  components_footer_registration_number: 'Registracioni broj',
  components_footer_legal: 'Pravni odeljak',
  components_footer_terms: 'Uslovi i odredbe',
  components_footer_privacy: 'Politika privatnosti',
  button_load_more: 'Učitaj još',
  page_media_1_content_hero_text: 'Meditacije',
  page_media_content_menu_antistress: 'Antistres',
  page_media_content_menu_mindfulness: 'Svesnost',
  page_media_content_menu_energyboost: 'Energija',
  page_media_content_menu_mantra: 'Mantre',
  page_media_2_content_hero_text: '',
  page_text1_hero_text: 'Vodiči',
  page_text1_section_title: 'Vodiči',
  page_text1_subheader_text: 'Naši vodiči',
  page_text2_hero_text: '',
  page_text2_section_title: '',
  page_text2_subheader_text: '',
  enter_email_title: 'Unesite svoju e-mail adresu da biste nastavili',
  enter_email_placeholder_email: 'Email',
  enter_email_button_enter: 'Unesi',
  components_login_success_text: 'Prijava je uspela!',
  components_card_link_media_content: 'Slušaj sada',
  components_card_link_text1_content: 'Vidi vodič',
  components_card_link_text2_content: 'Vidi članak',
  france: 'Francuska',
  cyprus: 'Kipar',
  tag_podcast: 'Подкаст',
  tag_meditation: 'Медитација',
  page_media_content_menu_all: 'Sve',
};